export const LOGIN_USER = 'LOGIN_USER';
export const UPDATE_LOGIN_INFO_USER = 'UPDATE_LOGIN_INFO_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_IS_PASS_THROUGH_USER = 'SET_IS_PASS_THROUGH_USER';
